"use client"

import { Avatar, Button, Divider, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Progress, useDisclosure, useToast } from '@chakra-ui/react'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getCampaign } from '../services/api'
import { Spinner } from '@chakra-ui/react'
import { Campaign, mapApiResponseToCampaign } from '../interface'
import moment from 'moment';
import { GlobalContext } from '../App'
import Header from './header'
import facebook from '../assets/svgs/facebook.svg';
import twitter from '../assets/svgs/twitter.svg';
import whatsapp from '../assets/svgs/whatsapp.svg';
import ErrorView from './not_found'
import { CampaignStatusBanner } from './CampaignStatusBanner'

export default function CampaignDetails() {
    let navigate = useNavigate();
    let params = useParams();
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [loading, setLoading] = useState(true)
    const [isError, setIsError] = useState(false);
    // const [campaign, setCampaign] = useState<Campaign | undefined>();
    const ctx = useContext(GlobalContext);
    const toast = useToast()
    var campaign = ctx?.get;
    const contributionsCount = campaign?.totalContributions ?? 0;

    const getData = useCallback(() => {
        setIsError(false);
        if (params.id) {
            setLoading(true);
            getCampaign(params.id)
                .then((response) => {
                    console.log('API Response:', response);
                    const mappedCampaign = mapApiResponseToCampaign(response);
                    const sharingUrl =
                        response.social_sharing?.direct || mappedCampaign.url || window.location.href;
                    // Format createdAt for display
                    const formattedCampaign = {
                        ...mappedCampaign,
                        // Keep UI routing consistent: campaign URL param is the public token
                        id: params.id,
                        createdAt: moment(response.created_at).fromNow(),
                        url: sharingUrl,
                    };
                    ctx?.set(formattedCampaign as Campaign);
                })
                .catch((error) => {
                    console.error('Failed to load campaign:', error);
                    setIsError(true);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            window.location.assign('https://motito.co');
        }
    }, [ctx, params.id]);

    useEffect(() => {
        localStorage.removeItem('MOTITO')
        getData();
    }, [getData])

    let totalPercentage = ((campaign?.amount_raised ?? 0) / (campaign?.product.retail_price ?? 0) * 100);
    const campaignStatus = String(campaign?.status || '').toUpperCase();
    const isExpired = Boolean(
        campaign?.expires_at ? new Date(campaign.expires_at).getTime() < Date.now() : false
    );
    const isActive = campaign?.is_active !== false && campaignStatus === 'ACTIVE';
    const canDonate = isActive && !isExpired && totalPercentage < 100;

    const shareUrl = campaign?.social_sharing?.direct || campaign?.url || window.location.href;

    return (

        <div className='' >

            <Header />
            {isError ? <ErrorView retry={getData} /> : loading ?
                <div className='w-full flex justify-center mt-16 ' >
                    <Spinner className='' />
                </div> :

                <div className='max-w-[500px] px-4 mx-auto space-y-4 mt-3 mb-10'>
                    <CampaignStatusBanner
                        status={campaignStatus}
                        isActive={isActive}
                        expiresAt={campaign?.expires_at}
                        goalReached={totalPercentage >= 100}
                    />
                    <div className='bg-[#F9F9FB] p-[20px] rounded-[10px]'>
                        <p className='text-[#0E1736] font-bold text-2xl mb-5'>{campaign?.title ?? ""}</p>
                        <div className='flex  items-center'>
                            <div className='w-[134px] h-[107px] overflow-clip rounded-[10px]'>
                                <img className='w-full h-full object-cover' src={campaign?.product.image_url.url} alt="" />
                            </div>
                            <div className='space-y-2 ml-[14px]'>
                                <p>{campaign?.product.name}</p>

                                <p className='text-[20px] font-bold text-[#5C6278]'>₵{campaign?.product.retail_price.toFixed(2) ?? ''}</p>
                            </div>
                        </div>
                    </div>

                    <div className=' p-3'>
                        <p> <span className='font-bold text-[#0E1736]'  >GHS {campaign?.amount_raised?.toLocaleString() ?? 0.0} </span> raised of GHS {campaign?.product.retail_price}</p>
                        <Progress size={'sm'} value={totalPercentage} rounded={'md'} colorScheme='green' color={'#4CB27E'} bgColor={'#EFF0F6'} />
                    </div>

                    <div className='flex gap-4' >
                        <div className='bg-[#F9F9FB] p-[10px] rounded-full'>
                            <p>{campaign?.createdAt.toString()}</p>
                        </div>


                        <div className='bg-[#F9F9FB] p-[10px] rounded-full'>
                            <p>{contributionsCount} Donation{contributionsCount > 1 ? 's' : ''} </p>
                        </div>
                    </div>
                    <Divider />
                    <div className='flex justify-center gap-4 flex-col md:flex-row text-sm mt-[24px]'>


                        <Button onClick={() => {
                            if (canDonate) {
                                navigate('/pay/' + params.id)
                            }
                        }} disabled={!canDonate} width={'full'} size={'lg'} variant='solid' textColor={'white'} className=' text-white hover:bg-opacity-90 bg-[#0B419C]' >
                            <p>Donate</p>
                        </Button>

                        <Button borderColor={'#0E1736'} onClick={onOpen} width={'full'} size={'lg'} variant='outline'>
                            <p>Share</p>
                        </Button>
                    </div>
                    <div>
                        <p className='text-[#0E1736] font-bold mb-2'>About Campaign</p>
                        <p className='text-[#101E32] text-sm'>
                            {campaign?.description}
                        </p>
                    </div>
                    <div>
                        <p className='text-[#5C6278] text-sm mb-1'>Fundraiser</p>
                        <div className='flex bg-[#F9F9FB] rounded-[20px] gap-2 p-3 text-sm'>
                            <Avatar src={campaign?.user_avatar} />
                            <div >
                                <p className='font-[500]'>{campaign?.user_name}</p>
                                <p className='font-normal'>{campaign?.user_phone_number}</p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <Button onClick={() => {
                            window.open('https://motito.co', '_blank')
                        }} fontSize={'sm'} fontWeight={'normal'} color={'white'} rounded={'full'} className='w-full text-sm font-normal bg-[#2E384B] hover:bg-opacity-90'  >
                            Learn more about motito pay for me.
                        </Button>
                    </div>
                </div>}

            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        <p className='text-xl font-bold text-[#2E384B]'>Help spread the word.</p>
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <div className='max-w-[500px] px-4 mx-auto space-y-4 mt-3 mb-10 '>

                            <div className='text-center'>

                                <p className='text-lg'>
                                    You can share this campaign to spread the word and help <span className='font-bold'>{campaign?.user_name} </span> reach his target faster.
                                </p>
                            </div>

                            <div >
                                <p className='text-sm'>Copy Link </p>
                                <div className='flex gap-3'>
                                    <Input readOnly value={shareUrl} className='border p-4 rounded-md flex-auto' />
                                    <Button className=' text-white hover:bg-opacity-90 bg-[#0B419C]' onClick={() => {
                                        navigator.clipboard.writeText(shareUrl);
                                        toast({
                                            title: 'Copied!',
                                            description: 'Sharing link has been copied',
                                            duration: 2500,
                                            position: 'top'
                                        })
                                    }} >
                                        Copy
                                    </Button>
                                </div>
                            </div>

                            <div className='flex gap-8 w-fit mx-auto text-center'>
                                <div onClick={() => {
                                    // Use backend-provided WhatsApp link or fallback
                                    const whatsappUrl = campaign?.social_sharing?.whatsapp || `https://wa.me/?text=${encodeURIComponent(shareUrl)}`;
                                    window.open(whatsappUrl, '_blank')
                                }} className='w-fit cursor-pointer' >
                                    <img className='mx-auto' src={whatsapp} alt="" />
                                    <p>What's App</p>
                                </div>

                                <div onClick={() => {
                                    // Use backend-provided Facebook link or fallback
                                    const facebookUrl = campaign?.social_sharing?.facebook || `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
                                    window.open(facebookUrl, '_blank')
                                }} className='w-fit cursor-pointer'>
                                    <img className='mx-auto' src={facebook} alt="" />
                                    <p>Facebook</p>
                                </div>

                                <div onClick={() => {
                                    // Use backend-provided Twitter link or fallback
                                    const twitterUrl = campaign?.social_sharing?.twitter || `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}`;
                                    window.open(twitterUrl, '_blank')
                                }} className='w-fit cursor-pointer'>
                                    <img className='mx-auto' src={twitter} alt="" />
                                    <p>Twitter</p>
                                </div>

                            </div>

                        </div >
                    </ModalBody>

                    <ModalFooter>
                        <Button onClick={onClose} variant='ghost'> Close </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>


        </div>
    )
}
